import { IInitialState } from '../../../reduxService';
import { convertTo, EConversionImperialToSI } from '../../conversion';
import { UnitOfMeasure } from '../../enum/project';
import { IProjectInfoForm } from '../../pages/ProjectInfo/IProjectInfo';
import { IGeometryForm } from '../components/InputForm/Geometry/Geometry';
import { IHydraulicDataForm } from '../components/InputForm/HydraulicData/IHydraulicData';
import { IMaterialSubSectorSlice } from '../store/project/projectSlice';

export const conversion = (store: any) => (next: any) => (action: any) => {
    let projectInfo: IInitialState<IProjectInfoForm> = store.getState().projectInfo;
    let isImperial = projectInfo.data?.unitOfMeasure == UnitOfMeasure.Imperial;
    if (action.type == 'projectMacra1/setHydraulicData' && isImperial) {
        let hydraulicData: IHydraulicDataForm = action.payload;
        hydraulicData = {
            ...hydraulicData,
            discharge: convertTo(hydraulicData.discharge, EConversionImperialToSI.ft3s_to_m3s),
            freeboard: convertTo(hydraulicData.freeboard, EConversionImperialToSI.ft_to_m),
            radius: convertTo(hydraulicData.radius, EConversionImperialToSI.ft_to_m),
            soilAdmissibleVelocity: convertTo(hydraulicData.soilAdmissibleVelocity, EConversionImperialToSI.fts_to_ms),
        };
        action.payload = hydraulicData;
    }

    if (action.type == 'projectMacra1/setSector' && isImperial) {
        let geometryForm: IGeometryForm = action.payload;
        geometryForm = {
            ...geometryForm,
            height: convertTo(geometryForm.height, EConversionImperialToSI.ft_to_m),
            width: convertTo(geometryForm.width, EConversionImperialToSI.ft_to_m),
            length: convertTo(geometryForm.length, EConversionImperialToSI.ft_to_m),
        };
        action.payload = geometryForm;
    }

    if (action.type == 'projectMacra1/setMaterialToSubSector' && isImperial) {
        let materialSubSector: IMaterialSubSectorSlice = action.payload;
        materialSubSector = {
            ...materialSubSector,
            subsectors: materialSubSector.subsectors.map(x => ({
                ...x,
                length: convertTo(x.length!, EConversionImperialToSI.ft_to_m),
            })),
        };
        action.payload = materialSubSector;
    }

    return next(action);
};
